<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="身份认证名称">
          <el-input placeholder="请输入身份认证名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加身份认证</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="name" label="身份认证名称"></el-table-column>
            <el-table-column prop="id_num" label="身份证"></el-table-column>
            <el-table-column prop="wx_id" label="微信号"></el-table-column>
            <el-table-column prop="zfb_id" label="支付宝账号"></el-table-column>
            <el-table-column prop="real_name" label="真实姓名"></el-table-column>
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
								<el-button @click="auditClick(scope.row)" type="text" size="small"> {{ scope.row.status === 1 || scope.row.status === 2 ? '已审核' : '审核' }}</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>

      
		<el-dialog title="实名认证审核" :visible.sync="auditDialogVisible" width="500px">
			<el-form :model="currentAuditRow" label-width="100px">
				<el-form-item label="名称">
					<el-input v-model="currentAuditRow.name" disabled></el-input>
				</el-form-item>

				<el-form-item label="审核结果" required>
					<el-radio-group v-model="currentAuditRow.status">
						<el-radio :label="1">通过</el-radio>
						<el-radio :label="2">不通过</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="审核意见" v-if="currentAuditRow.status === 2">
					<el-input type="textarea" v-model="currentAuditRow.review_comments" placeholder="请输入不通过原因"
						:rows="3"></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="auditDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleAuditSubmit">确 定</el-button>
			</div>
		</el-dialog>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :identity_verification_id="identity_verification_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import Identity_verificationApi from '@/api/identity_verification.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
         currentAuditRow: {}, // 新增：存储当前审核的行数据
        auditDialogVisible: false,
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        identity_verification_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    onShow() {
    
    },
    methods: {		
 
auditClick(row) {
  this.currentAuditRow = {
    ...row,          // 保留原有数据
    status: 1,       // 默认通过
    // review_comments: '' // 清空意见
  };
  this.auditDialogVisible = true;
},
      handleAuditSubmit() {
			  const postData = {
          identity_verification_id:this.currentAuditRow.identity_verification_id,
			    status: this.currentAuditRow.status,
			    review_comments: this.currentAuditRow.review_comments,
			  };
			  Identity_verificationApi.updatestatus(postData,true).then(data => {
						this.$message.success('审核成功');
			        this.auditDialogVisible = false;
			        this.getTableList();
					})
					.catch(error => {
						console.log(error);
						
					});
			
			},
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//身份认证标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Identity_verificationApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.identity_verification_id = row.identity_verification_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Identity_verificationApi.del(
              {
                identity_verification_id: row.identity_verification_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/identity_verification/index/index.vue